import { useCallback, useState } from 'react'

/**
 * Linhas abertas numa tabela com detalhe que abre na própria linha
 * (descrição longa, cláusula). Várias podem ficar abertas ao mesmo tempo.
 */
export function useExpandedRows() {
  const [open, setOpen] = useState<ReadonlySet<string>>(new Set())
  const isOpen = useCallback((key: string) => open.has(key), [open])
  const toggle = useCallback((key: string) => setOpen(prev => {
    const next = new Set(prev)
    if (next.has(key)) next.delete(key)
    else next.add(key)
    return next
  }), [])
  return { isOpen, toggle }
}
